import {Injectable} from '@angular/core';
import {Constants} from '../constants/ebtq-constants';

// tslint:disable: prefer-const
// tslint:disable: triple-equals
// tslint:disable: max-line-length
@Injectable()
export class CommonUtils {

  constructor() {
  }


  public removeSpaces(desc: string): string {
    return desc.replace(/\s/g, '');
  }

  public getCurrentReportingPeriod(): string {
    return this.getYearMonth(1);
  }

  // Get YearMonth in yyyyMM format
  public getYearMonth(addToMonth: number): string {
    const today = new Date();
    const currentYear = today.getFullYear().toString();
    const month = today.getMonth() + addToMonth;
    const fullMonth = month < 10 ? '0' + month : month.toString();
    const yearMonth = currentYear + fullMonth;
    return yearMonth;
  }

  public lastFourMonths(): {label: string, value: string}[] {
    const today = new Date();
    const currentYear = today.getFullYear();
    const month = today.getMonth() + 1;
    const previousFourMonthsList = [];
    for (let i = 0; i < 3; i++) {
      const previousMonth = month - i;
      let previousYear = currentYear;
      let monthValue = previousMonth;
      switch (previousMonth) {
        case 0:
          monthValue = 12;
          previousYear = currentYear - 1;
          break;
        case -1:
          monthValue = 11;
          previousYear = currentYear - 1;
          break;
      }
      const currentFullMonth = monthValue < 10 ? '0' + monthValue : monthValue.toString();
      const yearMonth = currentFullMonth + '/' + previousYear;
      const map = {label: yearMonth, value: yearMonth};
      previousFourMonthsList.push(map);
    }
    return previousFourMonthsList;
  }

  /* Method is used to get the last n months and return a list of them */
  /*
     rptCode is an optional parameter if a report's reporting period is needed to start in the next month
     rather than the current month.
  */
  public lastNYearMonths(n: number, rptCode?: string): {label: string, value: string}[] {
    const dateObj = new Date();
    let currentMonth = 0;

    // Checks if rptCode is Daily Report - 27 (RPT_27)
    // This report's reporting period starts in the next month
    if (typeof rptCode !== 'undefined' && rptCode === 'RPT_27')
    {
      currentMonth = dateObj.getMonth() + 2;
    }

    else
    {
      currentMonth = dateObj.getMonth() + 1;
    }

    let currentYear = dateObj.getFullYear();

    const previousNMonthsList = [];
    let monthVal = currentMonth;

    // Get the last n months including the current year and month
    for (let i = 0; i < n + 1; i++)
    {
      if (monthVal === 0)
      {
        // Change monthVal to 12 (December)
        monthVal = 12;
        currentYear -= 1;
      }

      const yearMonth = monthVal < 10 ? currentYear.toString() + ('0' + monthVal) :
        currentYear.toString() + monthVal.toString();

      const map = {
        label: yearMonth,
        value: yearMonth
      };

      previousNMonthsList.push(map);
      monthVal -= 1;
    }

    return previousNMonthsList;
  }

  // Get MonthName and Year in MMMMM yyyy format
  public getMonthNameAndYear(addToMonth: number): string {
    const today = new Date();
    const currentYear = today.getFullYear().toString();
    const month = today.getMonth() + addToMonth;
    const monthName = Constants.MONTH_NAMES[month];
    const monthNameYear = monthName + ' ' + currentYear;
    return monthNameYear;
  }

  public getPreviousReportingPeriod(): string {
    return this.getYearMonth(0);
  }

  // check for duplicate
  public containsDuplicates(arr: any[]): boolean {
    const sorted_arr = arr.slice().sort();
    const results = [];
    for (let i = 0; i < sorted_arr.length - 1; i++) {
      if (sorted_arr[i + 1] === sorted_arr[i]) {
        results.push(sorted_arr[i]);
      }
    }
    return results.length > 0;
  }

}
